import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 */
const getZonedUTCDate = (
  timeZone: string | null = null,
  date: Date = new Date(),
): Date => zonedTimeToUtc(date, timeZone);

export default getZonedUTCDate;
